import { getCountryDefinition } from '@/locales/supportedLocales.ts';
import i18n from '@/plugins/vue-i18n.js';
import { useAccountStore } from '@/store/modules/account/store.js';
import Enum from './Enum.js';

export default class Country extends Enum {
    static get contract() {
        return useAccountStore().contextAccount?.localization;
    }

    static get entries() {
        return Object.fromEntries(
            (this.contract?.countries || [])
                .filter((country) => country.enabled !== false && typeof country.code === 'string')
                .map((country) => {
                    const code = country.code.trim().toUpperCase();

                    return [code, code];
                })
        );
    }

    static getTranslation(value) {
        const definition = getCountryDefinition(value, this.contract);

        if (!definition) {
            return typeof value === 'string' ? value : '';
        }

        if (definition.translation_key && i18n.te(definition.translation_key)) {
            return i18n.t(definition.translation_key);
        }

        return definition.name || definition.code;
    }

    static get CA() {
        return this.entries.CA;
    }

    static get US() {
        return this.entries.US;
    }

    static get BE() {
        return this.entries.BE;
    }
}
